export const ROUTES = {
    home: '/',
    about: '/about',
    treatements: '/treatements',
    contactUs: '/contactUs',
}